/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Terms_Form_Privacyconsent_Label1Inputs */

const en_register_onboarding_terms_form_privacyconsent_label1 = /** @type {(inputs: Register_Onboarding_Terms_Form_Privacyconsent_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I agree to the privacy policy`)
};

const de_register_onboarding_terms_form_privacyconsent_label1 = /** @type {(inputs: Register_Onboarding_Terms_Form_Privacyconsent_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich stimme der Datenschutzerklärung zu`)
};

/**
* | output |
* | --- |
* | "I agree to the privacy policy" |
*
* @param {Register_Onboarding_Terms_Form_Privacyconsent_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const register_onboarding_terms_form_privacyconsent_label1 = /** @type {((inputs?: Register_Onboarding_Terms_Form_Privacyconsent_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Terms_Form_Privacyconsent_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_terms_form_privacyconsent_label1(inputs)
	return en_register_onboarding_terms_form_privacyconsent_label1(inputs)
});
export { register_onboarding_terms_form_privacyconsent_label1 as "register_onboarding_terms_form_privacyConsent_label" }